"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateApi = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var StateApi = /** @class */ (function (_super) {
    tslib_1.__extends(StateApi, _super);
    function StateApi(config) {
        return _super.call(this, config) || this;
    }
    // Load states info form GET /api/danfoss-location/countries/{code}/divisions
    StateApi.prototype.loadStatesInfo = function (countryCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params;
            return tslib_1.__generator(this, function (_a) {
                params = {
                    countryCode: countryCode,
                };
                return [2 /*return*/, this.getData(params)];
            });
        });
    };
    // Load states translation from GET /api/danfoss-location/countries/{code}/divisions?language={language}
    StateApi.prototype.loadTranslatedStates = function (countryCode, language) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var params;
            return tslib_1.__generator(this, function (_a) {
                params = { countryCode: countryCode, language: language };
                return [2 /*return*/, this.getData(params)];
            });
        });
    };
    // Extended from BaseApi
    StateApi.prototype.callApi = function (url, params) {
        var divisionsUrl = "".concat(url).concat(StateApi.API_PATH, "/").concat(params.countryCode, "/").concat(StateApi.API_KEY_WORD);
        var additionalParams = params.language ? { language: params.language } : null;
        return _super.prototype.callApi.call(this, divisionsUrl, additionalParams);
    };
    // Extended from BaseApi
    StateApi.prototype.serialize = function (data, params) {
        var states = data.value;
        if (!states || states.length < 1) {
            return null;
        }
        if (this.canUseStorage()) {
            var retrievedStatesJSON = this.storageWithExpiration.getDataFromStorage(this.config.storageKey);
            var allStates = retrievedStatesJSON ? app_1.JSONService.parse(retrievedStatesJSON) : {};
            if (allStates) {
                allStates[params.countryCode] = data;
                return JSON.stringify(allStates);
            }
        }
        return null;
    };
    // Extended from BaseApi
    StateApi.prototype.deserialize = function (data, params) {
        if (!data) {
            return null;
        }
        var allStates = app_1.JSONService.parse(data);
        if (allStates && allStates[params.countryCode]) {
            return allStates[params.countryCode];
        }
        return null;
    };
    StateApi.STATE_PREFIX = 'region';
    StateApi.API_KEY_WORD = 'divisions';
    StateApi.API_PATH = '/danfoss-location/countries';
    return StateApi;
}(app_1.BaseApi));
exports.StateApi = StateApi;
